export default {
  props: {
    step: {
      type: Number,
      default: void 0,
      required: true
    },

    currentStep: {
      type: Number,
      default: void 0,
      required: true
    }
  },

  computed: {
    shouldRender () {
      const range = 1
      return this.step >= (this.currentStep - range) && this.step <= (this.currentStep + range)
    },

    shouldComputeProperties () {
      return this.shouldRender
    }
  }
}
